module.exports = __webpack_public_path__ + "img/hold.f8003a12.png";